import { request } from "@umijs/max";

// 获取二级商户列表
export async function getSubMerchantPage({
  pageSize,
  current,
  filter,
  sorter,
}: {
  pageSize: number;
  current: number;
  filter: API.FormValues;
  sorter: string;
}) {
  return request("/api/super/subMerchant/page", {
    method: "POST",
    data: {
      pageSize,
      current,
      filter,
      sorter,
    },
  });
}

// 获取二级商户详情
export async function getSubMerchantInfo(values: API.FormValues) {
  return request("/api/super/subMerchant/info", {
    method: "POST",
    data: values,
  });
}

// 创建二级商户
export async function addSubMerchant(values: API.FormValues) {
  return request("/api/super/subMerchant/add", {
    method: "POST",
    data: values,
  });
}

// 编辑二级商户
export async function editSubMerchant(values: API.FormValues) {
  return request("/api/super/subMerchant/edit", {
    method: "POST",
    data: values,
  });
}

// 删除二级商户
export async function removeSubMerchant(values: API.FormValues) {
  return request("/api/super/subMerchant/remove", {
    method: "POST",
    data: values,
  });
}
